const defaultReturnTo = '/';

const decodeUriComponentSafe = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const sanitizeReturnTo = (value?: string | null) => {
  if (!value) {
    return defaultReturnTo;
  }

  const decoded = decodeUriComponentSafe(value);

  try {
    const parsedUrl = new URL(decoded, window.location.origin);

    if (parsedUrl.origin !== window.location.origin) {
      return defaultReturnTo;
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return defaultReturnTo;
  }
};
